import { all } from 'redux-saga/effects';

import userAuthSagas from './userAuth/sagas';
import fccCommonSagas from './fccCommon/sagas';

export default function* globalSaga() {
  yield all([...userAuthSagas, ...fccCommonSagas]);
}
